import React, { useContext } from 'react';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import { UserContext } from '../UserContext';
import { useState, useEffect } from "react";
import Footer from '../Footer';
import './GraphicCourseDetails.css';
import { useNavigate } from 'react-router-dom';
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import FeeStructure from '../components/FeeStructure';
import Testimonials from '../Testimonials';
import display from './GraphicCourseImages/display.png';
import figmaImg from './GraphicCourseImages/figma.png';
import design1 from './GraphicCourseImages/design1.png';
import design2 from './GraphicCourseImages/design2.png';
import design3 from './GraphicCourseImages/design3.jpg';

const FigmaCourse = ({ selectedCourse }) => {
  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  
  useEffect(() => {
          const fetchData = async () => {
           await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
              credentials: 'include',
            }).then(response => {
                console.log("Response:",response);
              response.json().then(userInfo => {
                console.log("userinfo:",userInfo);
                setUserInfo(userInfo);
    
                if(userInfo?.usertype)
                {
                  const uType=userInfo?.usertype;
                  setUserRole(uType);
                }
              const uname = userInfo?.username;
              const avatar = userInfo?.avatar; // Store the avatar in a separate variable
              console.log("Uname: ", uname);
              console.log("Avatar: ", avatar);
    
              })
              .catch(err=> console.log("Error in useeffect:",err))
            });
          }
          fetchData();
        }, [isAdmin, isTeacher, isStudent, isGuest]);
      const determineUserRole = (usertype) => {
            console.log("In home.js:",usertype)
            if(usertype === 'Student')
              return "Student";
            else if(usertype === 'Teacher')
              return "Teacher";
            else if(usertype === 'Admin')
              return "Admin";
            else
              return "guest";
      };
     const navigate=useNavigate();
      const onLogin = (usertype) => {
        const userRole = determineUserRole(usertype);
        console.log("Calling setUserRole.")
        setUserRole(userRole);
      };
    
      function onLogout() {
          console.log("inside Onlogout.");
          fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
            credentials: 'include',
            method: 'POST',
          });
          setUserInfo(null);
          setUserRole('guest');
          navigate("/");
    
        }

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  return (
    <div>
      {/* Navbar */}
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && isGuest && <GuestNav onLogin={onLogin} />}

      {/* Hero Section */}
      <div className="ScratchProg-Background">
        <section className="section">
          <p className="PageHead" style={{ color: "#8b0194" }}>UI/UX Design with Figma</p>
          <div className="PageDesc">
            <div style={{ display: "flex" }}>
              <p style={{
                fontFamily: "'DM Sans', sans-serif",
                textAlign: "left",
                padding: "30px",
                fontSize: "22px",
                zIndex: 1,
                color: "#8b0194",
                width: "70%"
              }}>
                Discover the exciting world of digital design! Our Figma course teaches kids the fundamentals of UI/UX design, 
                from creating simple icons to designing complete apps and websites. Perfect for creative minds, this course 
                develops visual design and prototyping skills through hands-on projects.
              </p>
              <img style={{ minWidth: "250px", maxWidth: "450px" }} src={display} alt="Figma Interface" />
            </div>
            <div className="btn-row d-flex btn-row-resp btn-row-resp1">
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-course" href="#course">Course Structure</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-fee" href="#fee">Fee Structure</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-Testimonal" href="#testimonal">Testimonials</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-Faq" href="#Faq">FAQs</a>
              </div>
              <div style={{ width: "auto", height: "50px" }}>
                <a className="btn-row-resp button btn-color-registered" href="#">Get Registered</a>
              </div>
            </div>
          </div>
        </section>
        <div className="overlay"></div>
      </div>

      {/* Intro Section */}
      <div className='scratch-background'>
        <section className="section">
          <p className="PageHead" style={{ color: "#8b0194" }}>What is Figma?</p>
          <div className="PageDesc">
            <p style={{
              color: "#8b0194",
              marginTop: "2vh",
              fontSize: "18px",
              fontFamily: "sans-serif",
            }}>
              Figma is a powerful design tool used by professionals to create user interfaces, websites, and mobile apps. 
              It's a collaborative platform that allows designers to work together in real-time, making it perfect for 
              learning teamwork and design thinking.
              <br /><br />
              Through this course, students will learn the complete design process from concept to prototype. They'll 
              develop skills in visual design, user experience principles, and interactive prototyping. The course 
              culminates with students creating their own app and website designs ready for presentation.
              <br /><br />
              No prior design experience is needed - we'll start with the basics and gradually build up to professional-level 
              design skills in a fun, engaging way!
            </p>
          </div>
        </section>
      </div>

      {/* Course Structure */}
      <section className="section course-structure" id="course">
        <p className="PageHead" style={{ color: "#8b0194" }}>Course Structure and Syllabus</p>
        
        <h4 className="H4_Heading" style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <b>Course Objectives</b>
        </h4>
        <ul style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <li>Master Figma's interface and design tools</li>
          <li>Understand UI/UX design principles</li>
          <li>Create mobile app interfaces and website layouts</li>
          <li>Develop interactive prototypes</li>
          <li>Build a complete design portfolio</li>
        </ul>

        {/* Module 1 */}
        <div>
          <p className='moduleSection'>
            <img src={figmaImg} alt="" style={{ width: "2em", height: "2em" }} />
            Module 1: Figma Basics & Simple Designs
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />1</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>6</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>3</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Figma Fundamentals
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students will learn the Figma interface, basic shapes, text tools, and design principles. 
                They'll create simple icons, buttons, and layouts while understanding the fundamentals of UI design.
              </p>
            </p>
          </div>
        </div>

        

        {/* Module 2 */}
        <div>
          <p className='moduleSection'>
            <img src={figmaImg} alt="" style={{ width: "2em", height: "2em" }} />
            Module 2: App Design & Prototyping
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />2</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>6</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>2</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Mobile App Design
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students will design complete mobile app interfaces, learn about user flows, and create interactive 
                prototypes. They'll understand how to make designs that are both beautiful and functional.
              </p>
            </p>
          </div>
        </div>

       

        {/* Module 3 */}
        <div>
          <p className='moduleSection'>
            <img src={figmaImg} alt="" style={{ width: "2em", height: "2em" }} />
            Module 3: Website Design (Web & Mobile View)
          </p>
        </div>

        <div className="modules">
          <div className="round-box">
            <p style={{ marginTop: "5vh", color: "#cff7d5" }}>Module<br />3</p>
          </div>
          <div className="small-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Lessons
              <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>6</p>
            </p>
            <div className="small-box sm-box">
              <p style={{ margin: "auto" }}>
                Projects
                <p style={{ fontWeight: "lighter", marginBottom: "0px" }}>1</p>
              </p>
            </div>
          </div>
          <div className="large-box" style={{ color: "#249935" }}>
            <p style={{ margin: "auto" }}>
              Web Design Fundamentals
              <p style={{ fontWeight: "lighter", fontSize: "15px", marginBottom: "0px" }}>
                Students will learn responsive web design principles, create desktop and mobile website layouts, 
                and prototype multi-page websites. The module culminates in a complete educational website project.
              </p>
            </p>
          </div>
        </div>

        

        {/* Project Showcase */}
        <h6 style={{ color: "#8b0194", fontFamily: "sans-serif" }}>
          <b>Student Design Gallery</b>
        </h6>

        <div className="activityImagesContainer" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={design1} alt="App Design" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Mobile App Design</p>
          </div>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={design2} alt="Website Design" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Website Layout</p>
          </div>
          <div style={{ margin: "15px", textAlign: "center" }}>
            <img src={design3} alt="Game Interface" className='ActivityImages' style={{ maxWidth: "300px", borderRadius: "10px" }} />
            <p style={{ color: "#8b0194" }}>Game Interface</p>
          </div>
        </div>
      </section>

      {/* Fee Structure */}
      <FeeStructure subject="Design" />

      <Testimonials />

      {/* FAQs */}
      <div style={{ maxWidth: '100%', backgroundColor: '#edffff' }} id="Faq">
        <MDBContainer className="mt-0" style={{ maxWidth: '180vh' }}>
          <MDBAccordion alwaysOpen initialActive={1}>
            <div className="text-center PageHead" style={{ color: "#8b0194" }}> FAQs</div>
            <MDBAccordionItem collapseId={1} headerTitle="Q: What is Figma and why is it good for kids to learn?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                Figma is a professional design tool used to create websites, apps, and digital interfaces. It's great for kids because 
                it teaches design thinking, creativity, and problem-solving skills while being intuitive enough for beginners.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={2} headerTitle="Q: Does my child need any design experience for this course?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                No prior experience is needed! We start with the absolute basics and gradually build up skills. The course is designed 
                specifically for beginners with no design background.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={3} headerTitle="Q: What will my child be able to create after this course?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                By the end, students will have designed mobile apps, websites, and interactive prototypes. They'll complete several 
                projects that can be part of a design portfolio.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={4} headerTitle="Q: What computer requirements are needed for Figma?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                Figma runs in a web browser, so any relatively modern computer will work. It's available on Windows, Mac, and even Chromebooks. 
                A mouse is recommended but not required.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={5} headerTitle="Q: How does this course benefit my child's future?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                UI/UX design is a growing field with many career opportunities. Even if they don't become designers, the visual thinking, 
                creativity, and problem-solving skills learned are valuable in many professions.
              </span>
            </MDBAccordionItem>
            <MDBAccordionItem collapseId={6} headerTitle="Q: Will my child need to purchase Figma?">
              <strong style={{ color: "#8b0194" }}>A: </strong>
              <span style={{ color: "#8b0194" }}>
                No, Figma has a free plan that's perfect for learning. We'll show students how to set up their free account in the first lesson.
              </span>
            </MDBAccordionItem>
          </MDBAccordion>
        </MDBContainer>
      </div>

      <Footer />
    </div>
  );
};

export default FigmaCourse;